import { Component, AfterViewInit, OnInit, HostListener, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';
import { VendorSearchComponent } from '../../common/vendor-search/vendor-search.component';

import { AuthService } from '../../../services/common/auth.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-vendor-index',
  templateUrl: './vendor-index.component.html',
  styleUrls: ['./vendor-index.component.css'],
})
export class VendorIndexComponent implements OnInit, AfterViewInit {
  /**
   * Search select field options and default options
   * @type {any}
   */
  search_options: any = {
    per_page: 20,
    chart_of_accounts: [],
  };

  /**
   * Search params
   * @type {any}
   */
  search_params: any = {
    amount_equality: '=',
    page: 1,
    hide_zero_balance: false,
  };

  /**
   * Indicates that search request is being made
   * @type {boolean}
   */
  searching: boolean = false;

  /**
   * List of vendors in current page
   * @type {Array<any>}
   */
  vendors: Array<any> = [];

  /**
   * Total count of vendors in search results
   * @type {number}
   */
  count: number = 0;

  /**
   * Reference for matter search component
   * @param {[type]} 'matterSearch' html variable
   */
  @ViewChild('matterSearch', { static: true }) matterSearchComponent: MatterSearchComponent;

  /**
   * Reference for vendor search component
   * @param {[type]} 'vendorSearch' html variable
   */
  @ViewChild('vendorSearch', { static: true }) vendorSearchComponent: VendorSearchComponent;

  /**
   * Constructor
   * @param {Router}        private router        Angular router
   * @param {AuthService}   private authService   Auth service to get user groups
   * @param {VendorService} private vendorService Vendor service to connect to backend for vendor requests
   */
  constructor(private router: Router, private authService: AuthService, private vendorService: VendorService) {
    this.search_params.per_page = this.search_options.per_page;
    this.authService.fetchUserGroups().then((response_json) => {
      let groups = response_json.groups;
      if (groups.indexOf('personnel') > -1 || groups.indexOf('admin') > -1 || groups.indexOf('management') > -1 || groups.indexOf('owner') > -1)
        this.vendorService.getSearchOptions().then((response_json) => {
          this.search_options = response_json;
          this.search_params.per_page = this.search_options.per_page;
          this.loadVendors();
        });
      else this.router.navigate(['/']);
    });
  }

  // Component lifecycle methods

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called after view is ready
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500);
  }

  // Component methods

  /**
   * Clear contact search
   * @param {string} event event variable
   */
  clearContact(event: string) {
    this.search_params.contact_id = undefined;
  }

  /**
   * Clear matter search
   */
  clearMatter() {
    this.search_params.matter_id = undefined;
  }

  /**
   * Clear search to intial defaults
   */
  clearSearch() {
    this.search_params = {
      amount_equality: '=',
      page: 1,
      hide_zero_balance: false,
    };
    this.matterSearchComponent.clearSelectedMatter();
    this.vendorSearchComponent.clearSelectedVendor();
    this.loadVendors();
  }

  /**
   * Load vendors based on search
   */
  loadVendors() {
    this.searching = true;
    this.vendorService.getVendors(this.search_params).then((response_json) => {
      this.searching = false;
      this.vendors = response_json.results;
      this.count = response_json.count;
    });
  }

  /**
   * Set search param on contact select
   * @param {any} vendorItem item sent by search
   */
  onContactSelect(vendorItem: any) {
    this.search_params.contact_id = vendorItem.contact_id;
  }

  /**
   * Set search param on matter select
   * @param {any} matter_id Id of selected matter
   */
  onMatterSelect(matter_id: any) {
    this.search_params.matter_id = matter_id;
  }

  /**
   * Called on page change
   * @param {any} event Page change event
   */
  pageChanged(event: any) {
    this.search_params.page = event.page;
    this.loadVendors();
  }

  /**
   * Window scroll
   * @param {scroll'} 'window  [description]
   * @param {[type]}  '$event' [description]
   */
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  /**
   * Window resize
   * @param {resize'} 'window  [description]
   * @param {[type]}  '$event' [description]
   */
  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  /**
   * Sidebar UI height and position maintainer on scroll and resize
   */
  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  /**
   * Sidebar inner HTML height maintainer
   */
  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }
}
